import React, { PureComponent } from 'react';

import ModalComponent from '../../ui/Modal';

class BookingDisputeModalComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
    }

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit() {
    this.props.onSubmit();
  }

  renderBody() {
    return (<div>
      <div className="col-12">
        <strong>Warning:</strong> Marking a booking as disputed will stop any automated actions with this booking. Are you sure you want to mark this booking as disputed?
      </div>
    </div>)
  }

  renderButtonRow(onClose) {
    return (
      <div className="w-100 row align-items-center m-0">
        <div className="col pl-0">
          <button className='btn btn-secondary' onClick={onClose}>No</button>
        </div>
        <div className="col text-center">
          <button className='btn btn-primary' onClick={this.onSubmit} >Yes</button>
        </div>
      </div>
    )
  }

  render() {
    let { onClose } = this.props;
    return (<ModalComponent
      id="ConfirmationModal"
      title="Confirm Action"
      body={this.renderBody()}
      footer={this.renderButtonRow(onClose)}
      onClose={onClose} />
    );
  }
}

export default BookingDisputeModalComponent;
